/**
 * Worker Manger
 *      -Designed to manage all the work threads ensuring that 
 *          there are no more workers than the maximum number of workers allowed.
 */
var OCS = OCS || {};
OCS.Live = OCS.Live || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.define_worker_manager = function (in_implements) {
    var implements = [Options, Events];
    /* istanbul ignore if */
    if (in_implements && in_implements.length) {
        implements = implements.combine(in_implements);
    }
    if (OCS.Functions.is_workers_supported()) {
        implements = implements.combine([new Class(OCS.Interfaces.CSWorkers)]);
        if (OCS.Functions.is_shared_workers_supported()) {
            implements = implements.combine([new Class(OCS.Interfaces.CSSharedWorkers)]);
        }
        if (OCS.Functions.is_service_workers_supported()) {
            implements = implements.combine([new Class(OCS.Interfaces.CSServiceWorkers)]);
        }
    }
    return new Class({
        Implements: implements,
        class_name: "WorkerManager",
        manager_name: 'WorkerManager',
        bound_methods: {},
        idle_interval: null,
        status_check_interval: null,
        worker_status_check: [],
        warn_worker_removal: [],
        options: {
            events: {
                worker_available: "worker_available"
            },
            debug: false,
            max_number_of_worker_type: 4,
            max_number_of_active_workers: 6,
            time_between_workers: 5, // In ms
            status_check: 300000 // Perform a status check every 5 minutes
        },
        initialize: function (op) {
            if (OCS.Live[this.manager_name]) {
                return OCS.Live[this.manager_name];
            }
            /* istanbul ignore if */
            if (!this.worker_support) {
                this.worker_support = false;
            } else {
                this.init_workers();
            }
            /* istanbul ignore if */
            if (!this.shared_worker_support) {
                this.shared_worker_support = false;
            } else {
                this.init_shared_workers();
            }
            /* istanbul ignore if */
            if (!this.service_worker_support) {
                this.service_worker_support = false;
            }
            this.bound_methods.make_request = this.make_request.bind(this);



            /* istanbul ignore if */
            if (this.options.debug) {
                console.debug('Worker Manager Inited: ', this);
            }
            this.setOptions(op);

            this.status_check_interval = setInterval(this.on_status_check.bind(this), this.options.status_check);
            OCS.Live[this.manager_name] = this;
        },

        // Event Listeners
        on_status_check: function () {
            if (this.worker_support && this.on_worker_status_check) {
                this.on_worker_status_check();
            }
        },

        // Actions
        /**
         * 
         * @param {Object} request - contains msg and optionaly worker_id or path and or callback
         * @returns {Boolean}
         */
        make_request: function (request) {
            if (!request) {
                return false;
            }
            if (this.worker_support) {
                return this.make_worker_request(request);
            }
            return false;
        },

        queue_request: function (worker_request_info) {
            if (this.worker_support) {
                var worker_req = new OCS.Classes.WorkerDataRequest(worker_request_info);
                return worker_req;
            }
            return false;
        },
        
        // Booleans
        has_worker_available: function(request) {
            if (this.worker_support) {
                return this.is_worker_available(request);
            }
            return false;
        },
        
        
        // Get / Set methods

        set_debug: function (val) {
            this.options.debug = val;
        },
        set_max_number_of_worker_type: function (val) {
            this.options.max_number_of_worker_type = val;
        },
        set_max_number_of_active_workers: function (val) {
            this.options.max_number_of_active_workers = val;
        },

        destroy: function () {
            this.fireEvent('destroy', this);
            clearInterval(this.idle_interval);
            this.idle_interval = null;
            clearInterval(this.status_check_interval);
            this.status_check_interval = null;
            this.removeEvents();
            if (this.worker_support && this.destroy_workers) {
                this.destroy_workers();
            }

            OCS.Live[this.manager_name] = null;
            delete OCS.Live[this.manager_name];
        }
    });
};
OCS.Classes.WorkerManager = OCS.Functions.define_worker_manager();